import * as React from 'react';
import { cn } from '@/lib/utils';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const alertBannerVariants = cva(
  cn('relative items-center', 'min-h-11 md:min-h-12 lg:min-h-12'),
  {
    variants: {
      variant: {
        primary: 'bg-warp-green-100 text-black',
        success: 'bg-warp-green-400',
        danger: 'bg-status-danger',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
);

export interface AlertBannerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertBannerVariants> {}

export const AlertBanner = React.forwardRef<HTMLDivElement, AlertBannerProps>(
  ({ className, variant, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        data-component="CMSAlert"
        className={cn(alertBannerVariants({ variant, className }))}
        {...props}
      >
        {children}
      </div>
    );
  }
);
